<template>
  <div class="employee-item-card" @click="$router.push(`/employee/${employee.id}`)">
    <div class="employee-card-header">
      <div class="ml-2 pa-1 employee-name text-h6">{{ employee.firstname }} {{ employee.lastname }}</div>

      <img v-if="currentImage" :src="currentImage" :alt="initials" class="card-img primary" height="80px" />
      <v-avatar class="card-avatar" v-else color="primary" size="80px">
        <span class="white--text text-h4">{{ initials }}</span>
      </v-avatar>

    </div>
    <div class="pa-4 scroll-container background" style="border-radius:6px" :style="detailsHeight">
      <div class="section-container">
        {{
          `${employee.position ? employee.position : ''}${employee.position && employee.department ? ', ' : ''}${
            employee.department ? employee.department : ''
          }`
        }}
      </div>
      <employee-section v-if="showPhone" :display-list="employee.phone"></employee-section>
      <employee-section v-if="showMails" :display-list="employee.email"></employee-section>

      <div class="section-container">
        <div class="tags-inner-container">
          <v-chip color="accent" class="tag" v-for="tag in employee.tags" :key="tag">{{ tag }}</v-chip>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import index from './index';
import common from '@/mixins/common';
import employeeService from '@/modules/employee/employeeService';
import EmployeeSection from "@/modules/employee/EmployeeSection.vue";
import {mapState} from "vuex";

export default {
  name: 'EmployeeCard',
  components: {EmployeeSection},
  methods: {},
  mixins: [common],

  props: {
    employee: Object,
    photoFilename: String,
  },

  data() {
    return {
      showPhone: false,
      showMails:false
    }
  },

  computed: {
    ...mapState({ isConnected: (state) => state.isConnected, }),
    detailsHeight(){
      return `height:${(this.showPhone?60:0)+(this.showMails?60:0)+140}px`;
    },
    fileUrl() {
      let fileName = this.photoFilename;
      let fileUrl;
      if (fileName) {
        fileUrl = this.moduleFileUrl(index.moduleId, fileName);
      }
      return fileUrl;
    },
    currentImage() {
      if (this.fileUrl && this.isConnected) return this.fileUrl;
      return null;
    },
    person() {
      return this.employee;
    },
    initials() {
      return employeeService.getInitials(this.person);
    },
  },
};
</script>

<style scoped>
.employee-card-header {
  justify-content: space-between;
  display: flex;
  align-items: center;
}

.theme--dark .employee-item-card {
  background: #202020;
}

.theme--light .employee-item-card {
  background: #f0f0f0;
}

.theme--dark .details {
  border-top: 1px solid #303030;
  background: #1a1a1a;
}

.theme--light .details {
  border-top: 1px solid #e0e0e0;
  background: #fff;
}

.employee-name {
  overflow: scroll;
  display: flex;
  flex: 1;
  flex-wrap: wrap;
}

.card-img,
.card-avatar {
  display: flex;
  align-self: center;
  justify-self: flex-end;
  width: 80px;
  margin: 12px 12px 12px 20px;
  border-radius: 50px;
  border: 1px solid grey;
}

.employee-item-card {
  padding: 0;
  display: grid;
  border-radius: 6px;
}

.theme--dark .employee-item-card {
  border: 1px solid #808080;
}

.theme--light .employee-item-card {
  border: 1px solid #e0e0e0;
}

.section-container {
  display: flex;
  flex-wrap: wrap;
  align-self: center;
  flex: 1;
  gap: 5px;
  overflow-y: scroll;
  padding-right: 5px;
  padding-bottom:10px
}

.tags-inner-container {
  display: flex;
  flex-wrap: wrap;
}

.tag {
  margin: 1px;
}
</style>